import { useEffect, useState } from "react"
import GamMappingList from "./gamMappingList";
import ViewMappingOptions from "./viewMappingOptions";
import { useNavigate, useParams, Link } from "react-router-dom";
import API from "../../services/axiosInstance";
import PageViewsSetting from "./pageViewsSetting";
import { Col, Row } from "react-bootstrap";
import DisplayAdUnitSetting from "./displayAdUnitSetting";
import Permission from "../security/permission";
import { AUTH_CODE } from "../security/authCodes";

const ViewMapping = () => {

    const [mappingList, setMappingList] = useState([]);
    const [incExcPayload, setIncExcPayload] = useState('');
    const [publisherName, setPublisherName] = useState("");

    const params = useParams();
    const accId = params?.pubId;
    const gamId = params?.gamId;
    const gamMappingStatus = params?.showGamMapping;  //inclusion or exclusion or Both(2)

    const navigate = useNavigate();
    const gamMappingList = async () => {
        const res = await API.get(`/publisher/gam/setting/getGamMappingList/${gamId}/${gamMappingStatus}/${accId}`);
        if (res.status === 200) {
            const data = res?.data?.data;
            setMappingList(data);
            setPublisherName(res?.data?.name);
        }

    }
    //      callback function from GamMappingList
    function payload(data) {
        // console.log(data)
        // set payload to it
        setIncExcPayload(data);

    }

    // callback function from PageViews Setting
    async function submitPageViewPayload(data) {
        // console.log(data);
        const currPayload = {
            accId: incExcPayload?.accId || 0,
            gamAccountId: incExcPayload?.gamAccountId || 0,
            selectedData: incExcPayload?.selectedData || [],
            pageViewsCount: Number(data?.pvPayload?.pageViewsCount),
            pageViewsStatus: Number(data?.pvPayload?.pageViewsStatus),
            pageViewsType: Number(data?.pvPayload?.pageViewsType)
        };
        // console.log(currPayload);
        try {
            const res = await API.put(`/publisher/gam/setting/pageviews/update`, currPayload);

            if (res?.data?.status === "Success") {
                alert(res?.data?.message);
                window.location.reload();
                return;
            }
            alert(res?.data?.message || "Failed to update!");
        } catch (error) {
            console.error(error);
        }
    }

    // callback function from Display Ad Unit Setting
    async function submitDisplayAdPayload(data) {
        // console.log(data);
        const currPayload = {
            accId: incExcPayload?.accId || 0,
            selectedData: incExcPayload?.selectedData || [],
            gamAccountId: incExcPayload?.gamAccountId || 0,
            inclusionStatus: incExcPayload?.inclusionStatus || -1,
            displayAdUnit: data?.adUnitPayload?.name || ""
        }

        // console.log(currPayload)
        try {
            const res = await API.put(`/publisher/gam/setting/rename/ad/units`, currPayload);

            if (res?.data?.status === "Success") {
                alert(res?.data?.message);
                window.location.reload();
            }
            alert(res?.data?.message || "Failed to update!");
        } catch (error) {
            console.error(error);
        }

    }


    useEffect(() => {
        gamMappingList();
    }, [])

    return (
        <>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <span>Tech Admin</span>
                <Link to={'/gamsetting'}><span>Demand Partner 1 Setting</span></Link>
                <span>{publisherName}</span>
                <span>Update</span>
            </div>

            <Row>
                {/* ===== View Mapping ===== */}
                <Permission code={AUTH_CODE.demandPartner.inclusionExclusionAdUnit}>
                    <Col md={4}>
                        <ViewMappingOptions />
                    </Col>
                </Permission>


                {/* ===== Page Views Setting ===== */}
                <Permission code={AUTH_CODE.demandPartner.editUpdatePageViews}>
                    <Col md={4}>
                        <PageViewsSetting pageViewPayload={submitPageViewPayload} />
                    </Col>
                </Permission>

                {/* =====  Display Ad Unit Setting ===== */}
                <Permission code={AUTH_CODE.demandPartner.renameAdUnits}>
                    <Col md={4}>
                        <DisplayAdUnitSetting displayAdPayload={submitDisplayAdPayload} />
                    </Col>
                </Permission>

            </Row>

            <GamMappingList payload={payload} mappingList={mappingList} />
        </>
    )

}

export default ViewMapping;